module.exports = __webpack_public_path__ + "static/media/kaguya.29df6a45.jpg";